import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from "./loadingSuccess.module.scss";
import { connect } from 'react-redux';

const LoadingSuccess = (props) => {

    return (
       <>
            {
                props?.showSuccessCheckMark && (
                    <div className={styles.container}>
                        <div className={cn(styles.paymentStatusCircle,styles.success)}>{ '✔'}</div>
                    </div>
                )
            }
       </>
    )
};


const mapStateToProps = ({notification}) => ({
    showSuccessCheckMark: notification?.showSuccessCheckMark,
    duration: notification?.duration
});

export default connect(mapStateToProps, null)(LoadingSuccess);